import { render, staticRenderFns } from "./BusinessProcessMessageText.vue?vue&type=template&id=28ffbb4f&"
import script from "./BusinessProcessMessageText.vue?vue&type=script&lang=js&"
export * from "./BusinessProcessMessageText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog} from 'quasar'
component.options.components = Object.assign({QDialog}, component.options.components || {})
